module.exports = __webpack_public_path__ + "img/4.0b3d4e0e.svg";